module.exports = __webpack_public_path__ + "img/quxiao.1545a658.png";